'use client';
import { TemplateSidebar } from '@/src/packages/components/templates/TemplateSidebar';
import { CustomerSupportLinks } from '@/src/packages/components/ui/Footer/Footer.config';
import { NewsletterForm } from '@/src/packages/components/ui/NewsletterForm';
import { Paragraph } from '@/src/packages/components/ui/Paragraph';

export const Newsletter = () => {
  return (
    <TemplateSidebar title="Newsletter" links={CustomerSupportLinks}>
      <Paragraph textSize="2xl" marginBottom={6} size="lead" fontFamily="serif">
        Be the first to hear about our new product launches, and get 5% off your
        first order.
      </Paragraph>
      <NewsletterForm />
    </TemplateSidebar>
  );
};
